import { api } from '../../../api/common/instances';

const state = {
  partialTaskType: [],
  // Added.by.KWShin.2022.08.17.
  isPcapOs: null,
  // Added.by.KWShin.2024.01.12.
  codesLoadKind: [],
  // Added.by.KWShin.2024.01.14.
  codesLogonType: [],
  // Added.by.KWShin.2024.09.02.
  propCboList: [],
};

const getters = {};

const mutations = {
  setPartialTaskType(state, partialTaskType) {
    state.partialTaskType = partialTaskType;
  },
  setPcapOs(state, isPcap) {
    state.isPcapOs = isPcap;
  },
  setCodesLoadKind(state, codesLoadKind) {
    state.codesLoadKind = codesLoadKind;
  },
  setCodesLogonType(state, codesLogonType) {
    state.codesLogonType = codesLogonType;
  },
  setPropCboList(state, propCboList) {
    state.propCboList = propCboList;
  },
};

const actions = {
  async fetchPartialTaskType({ commit }) {
    // BEGIN::Modified.by.KWShin.2023.10.26. ROLE_USER 사용자는 /preference URL에 대한 접근 권한이 없어서 문제가 됨.
    // const { data } = await api.get('/preference/partial-task-type');
    const { data } = await api.get('/prefer/partial-task-type');
    // FINISH::Modified.by.KWShin.2023.10.26.
    commit('setPartialTaskType', data);
  },
  async isPcapOs({ commit }) {
    const { data } = await api.get('/prefer/is-collecting-pcap-os');
    commit('setPcapOs', data);
  },
  async fetchCodesLoadKind({ commit }) {
    const { data } = await api.get('/prefer/load-kind');
    commit('setCodesLoadKind', data);
  },
  async fetchCodesLogonType({ commit }) {
    const { data } = await api.get('/prefer/logon-type');
    commit('setCodesLogonType', data);
  },
  async fetchPropCboList({ commit }) {
    const { data } = await api.get('/prefer/cbo-list');
    commit('setPropCboList', data);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
